import React from "react";
import Modal from "@mui/material/Modal";
import { Box, Fade } from "@mui/material";
import { FormControl, Row } from "react-bootstrap";
import { useState, useEffect } from "react";

interface NewNameModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  name: string;
  setName: (value: string) => void;
  onComplete: () => void;
}

export default function NewNameModal({
  open,
  setOpen,
  name,
  setName,
  onComplete,
}: NewNameModalProps) {
  const [error, setError] = useState("");

  // Reset name to empty when modal opens
  useEffect(() => {
    if (open) {
      setName("");
      setError("");
    }
  }, [open, setName]);

  const handleCancel = () => {
    setName("");
    setOpen(false);
  };
  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
          }}
          className="p-4 bg-white rounded-4"
        >
          <h4 className="deleteTempateHeading aktiv text-center text-black">
            Enter Template Name
          </h4>
          <Row className="w_83_xl mx-auto my- mt-1">
            <FormControl
              required
              className="bg_link py-2 productSansLight text_14 my-3"
              placeholder="New Template Name"
              type="text"
              value={name}
              onChange={(e) => {
                setError("");
                setName(e.target.value);
              }}
            />
            {error && <div className="text-danger mt-1 text_12">{error}</div>}
          </Row>
          <div className="d-flex justify-content-center mt-4">
            <button
              onClick={handleCancel}
              className="button_text text-light m-0 w_8_rem py-1 mx-2 bgDisabled border-0 d-flex justify-content-center align-items-center button_text_signin"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                if (name.length < 4) {
                  setError("Name must be at least 4 characters");
                } else {
                  onComplete();
                }
              }}
              className={`button_text text-light m-0 w_8_rem py-1 mx-2 bgCreate border-0 d-flex justify-content-center align-items-center button_text_signin`}
            >
              Save
            </button>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
}
